"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
  className: "text-primary"
}, "The Managed Calendar"), /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "The \"Managed Calendar\" is the calendar of slalom competitions that take place during the current season. The Calendar Application System provides support for the process of agreeing the calendar in preparation for the", ' ', /*#__PURE__*/_react.default.createElement("em", null, "next"), "season. Clubs apply to run competitions and the various tiers are co-ordinated to avoid clashes etc."), /*#__PURE__*/_react.default.createElement("p", null, "At the ACM the calendar is approved, sometimes with ammendments. Additional information is then collected before the information is sent for printing in the yearbook and for display on www.canoeslalom.co.uk"));
const ManagedCalendar = () => {
  return _ref;
};
var _default = exports.default = ManagedCalendar;